import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Gatsby to NextJS pt1, server-side-render or server-side-generate?",
  "description": "Gatsby and NextJS do similar things differently. One is better for websites, the other for webapps. In episode 17 of CodeWithSwiz we explore the biggest difference.",
  "categories": "CodeWithSwiz, Technical, Gatsby, NextJS, Livecoding",
  "published": "2020-11-19T00:00:00.000Z",
  "hero": "./img/screenshot-1605802830206.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Gatsby and NextJS do similar things differently. One is better for websites, the other for webapps. In episode 17 of CodeWithSwiz we explore the biggest difference.`}</p>
    <p><em parentName="p">{`CodeWithSwiz is a twice-a-week live show. Like a podcast with video and fun hacking. Focused on experiments. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live Wednesdays and Sundays`}</a></em></p>
    <lite-youtube {...{
      "videoid": "ujglV7whNyc",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Spring last year I had a flash of insight: Modern web apps are static first! It solves so many problems 🤯`}</p>
    <p>{`Like `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/lessons-from-migrating-a-14-year-old-blog-with-1500-posts-to-gatsby#the-result-of-moving-to-gatsby"
      }}>{`time to first byte performance`}</a>{`, `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/the-ultimate-test-for-your-webapp:-airplane-wifi"
      }}>{`loading spinners of death on bad wifi`}</a>{`, and you can host from CDNs backed by a serverless data source. Works great.`}</p>
    <p>{`Following that hunch I built `}<a parentName="p" {...{
        "href": "https://spark-joy.netlify.app/"
      }}>{`Spark Joy`}</a>{` on a series of streams. The app you see under every email and article.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "764px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/6304c7773a6ada6ba1ae2101268e36aa/f3c12/Spark-Joy-feedback-widgets-in-email980e59.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "32.28699551569507%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'129\\'%20viewBox=\\'0%200%20400%20129\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M44%2035v9h6c8%200%2010-3%209-12%200-4-3-6-9-6h-6v9m33-7c0%202%200%203-3%202-3%200-6%203-6%208s2%206%209%206h4v-9c0-8%200-9-2-9l-2%202m147%207c0%208%200%209%202%209s2-1%202-5%201-5%202-5%202%201%202%205%200%205%202%205%202-1%202-6c0-6-1-9-5-8-3%201-3%200-3-2l-2-2c-2%200-2%201-2%209M90%2031l2%208c3%205%203%206%201%207l-1%202c0%202%204%202%205%200l6-18c-2-1-4%201-5%205l-1%205-2-5c-1-4-2-5-3-5l-2%201m16%202c-6%207%204%2016%2010%209l2-5c0-7-8-10-12-4m15-2v11c1%202%202%202%207%202h5v-7c0-5-1-7-2-7-2%200-2%201-2%205%200%205-1%206-2%206-2%200-3-1-3-6s-1-6-3-4m23%201c-4%203-2%2012%203%2012%203%200%205%200%207-2%201-2%201-2-3-2l-5-1%205-1c4%200%204%200%204-3-2-5-6-6-11-3m13%205c0%206%200%207%202%207s2-1%202-5l1-5c3-1%203%200%203%205%200%204%200%205%202%205s2-1%202-6c0-7-1-8-7-8h-5v7m23-4c-2%203-3%206%200%209%204%205%2012%202%2012-5s-8-10-12-4m14-1l2%208%201%206c-2%200-3%203-1%203h3c2-1%208-17%207-19-2-1-4%201-5%204%200%205-2%205-3%200%200-3-1-4-3-4s-2%200-1%202m54-1l-2%204c0%202%201%202%207%205v1l-4-1c-3-2-4%200-3%203l5%201c9%200%2010-7%202-9l-3-1h4c0%202%203%201%203%200%200-3-6-5-9-3m20%201c-5%205%201%2015%207%2012%205-2%205-4%200-4l-5-1%204-1c4%200%205%200%205-2%200-3-3-6-6-6l-5%202m13%205c0%206%200%207%202%207s2-1%202-5%200-5%202-5%202%201%202%205%200%205%202%205%202-1%202-5%200-5%202-5c1%200%202%202%202%205%200%204%200%205%202%205%203%200%203-8%200-12-1-2-4-3-6-1h-2l-6-1h-4v7m24-5l-2%202h7c1%201%200%201-3%202-4%201-4%201-4%204s3%206%205%204h4c3%200%203%200%203-5%200-7-2-9-6-9l-4%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6304c7773a6ada6ba1ae2101268e36aa/ca0a1/Spark-Joy-feedback-widgets-in-email980e59.webp 223w", "/static/6304c7773a6ada6ba1ae2101268e36aa/75680/Spark-Joy-feedback-widgets-in-email980e59.webp 445w", "/static/6304c7773a6ada6ba1ae2101268e36aa/79237/Spark-Joy-feedback-widgets-in-email980e59.webp 764w"],
                "sizes": "(max-width: 764px) 100vw, 764px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6304c7773a6ada6ba1ae2101268e36aa/e92b6/Spark-Joy-feedback-widgets-in-email980e59.png 223w", "/static/6304c7773a6ada6ba1ae2101268e36aa/e66bf/Spark-Joy-feedback-widgets-in-email980e59.png 445w", "/static/6304c7773a6ada6ba1ae2101268e36aa/f3c12/Spark-Joy-feedback-widgets-in-email980e59.png 764w"],
                "sizes": "(max-width: 764px) 100vw, 764px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6304c7773a6ada6ba1ae2101268e36aa/f3c12/Spark-Joy-feedback-widgets-in-email980e59.png",
                "alt": "Spark Joy feedback widgets in email",
                "title": "Spark Joy feedback widgets in email",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Spark Joy feedback widgets in email`}</figcaption>{`
  `}</figure></p>
    <p>{`Click a link, go to a page, answer followup questions. Works great.`}</p>
    <p>{`Except when the email software says 15 readers clicked a vote and Spark Joy gets 5 votes 🤔`}</p>
    <h2 {...{
      "id": "serversiderendering-and-serversidegeneration"
    }}>{`ServerSideRendering and ServerSideGeneration`}</h2>
    <p>{`When do you save that vote to the database?`}</p>
    <p>{`With server side rendering your pages are created in advance. You deploy your site, go through the database, render a page for each relevant entry and turn it into HTML with data baked-in.`}</p>
    <p>{`When users load a page, it hydrates and becomes a React app. You make requests in the browser and save the vote.`}</p>
    <p>{`This is the approach Gatsby uses.`}</p>
    <h3 {...{
      "id": "server-side-rendering"
    }}>{`Server side rendering`}</h3>
    <p>{`You create pages like this in `}<inlineCode parentName="p">{`gatsby-node.js`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`exports.createPages = async ({ graphql, actions }) => {
  const { createPage } = actions

  const result = await graphql(\`
    query {
      widgetsapi {
        allWidget {
          userId
          widgetId
          widgetType
          followupQuestions
        }
      }
    }
  \`)

  result.data.widgetsapi.allWidget.forEach(
    ({ userId, widgetId, widgetType, followupQuestions }) => {
      const votePath = path.resolve("./src/pages/vote.js")

      createPage({
        path: \`/\${widgetId}/thumbsup\`,
        component: votePath,
        context: {
          userId,
          widgetId,
          followupQuestions,
          widgetType,
          voteType: "thumbsup",
        },
      })
    }
  )
}
`}</code></pre>
    <p>{`The pattern you'll see is:`}</p>
    <ol>
      <li parentName="ol">{`Fetch data with GraphQL`}</li>
      <li parentName="ol">{`Iterate over data`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`createPage`}</inlineCode>{` for each with a data-driven URL`}</li>
    </ol>
    <p>{`Your page becomes static HTML served from a CDN. No servers. You read page params using the `}<inlineCode parentName="p">{`pageContext`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const VotePage = ({ pageContext }) => {
  const {
    userId,
    widgetId,
    voteType,
    followupQuestions,
    widgetType,
  } = pageContext

  return (
    <FullScreen>
      <SEO title="Thank You" />

      <FormView
        voteType={voteType}
        onSubmit={onSubmit}
        followupQuestions={followupQuestions}
        widgetType={widgetType}
      />
    </FullScreen>
  )
}
`}</code></pre>
    <p>{`Use props baked-in during deploy, render the page. No loading spinners.`}</p>
    <p>{`Because this is a static page, you save votes on load. And that's how you lose them. Folks load the page and bail before the save request completes.`}</p>
    <p>{`More on that next time ✌️`}</p>
    <h3 {...{
      "id": "server-side-generation"
    }}>{`Server side generation`}</h3>
    <p>{`NextJS supports server side rendering and it's gonna have the same problem: What if users bail before data saves?`}</p>
    <p>{`A "revolutionary" new approach that NextJS offers is server side generation. You'll recognize this as `}<em parentName="p">{`"How websites used to work 10 years ago"`}</em>{`.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media0.giphy.com/media/lQOeqOyNb97YLnoRex/giphy-loop.mp4?cid=7cf28b0fa8jxkegkdcygbwqal8udknd7cc9ytf4hgajlha6a&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`With server side generation you generate the page on-demand. User makes a request, serverless lambda (not managed by you) wakes up, fetches data, builds the page. User gets static HTML, it hydrates into a React app.`}</p>
    <p><inlineCode parentName="p">{`getServerSideProps`}</inlineCode>{` is how you turn that on:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`export async function getServerSideProps({ params }) {
  const { widgetId } = params
  const { data } = await client.query({
    query: gql\`
      query {
        allWidget {
          userId
          widgetId
          widgetType
          followupQuestions
        }
      }
    \`,
  })

  // TODO: support a query to fetch this directly
  const widget = data.allWidget.find((w) => w.widgetId === widgetId) || {}

  return { props: { widget } }
}
`}</code></pre>
    <p>{`Fetch data using GraphQL, return an object with `}<inlineCode parentName="p">{`props`}</inlineCode>{`. Supports redirects and other fun stuff.`}</p>
    <p>{`Where it differs from websites of old, is that your app uses the same code to render on the server `}<em parentName="p">{`and`}</em>{` in the browser. Seamlessly.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const VotePage = ({ widget }) => {
  const { userId, widgetId, voteType, followupQuestions, widgetType } = widget

  return (
    <Container sx={{ textAlign: "center" }}>
      <Head>
        <title>Thank you</title>
      </Head>

      <FormView
        voteType={voteType}
        onSubmit={onSubmit}
        followupQuestions={followupQuestions}
        widgetType={widgetType}
      />
    </Container>
  )
}
`}</code></pre>
    <p>{`You get data from props and use it to render the page. No loading spinners.`}</p>
    <p>{`And unlike with Gatsby, you have a chance to save data on every page load `}<em parentName="p">{`before the page loads`}</em>{`. Force users to wait. We'll try that next time.`}</p>
    <h2 {...{
      "id": "the-ssr-vs-ssg-tradeoff"
    }}>{`The SSR vs SSG tradeoff`}</h2>
    <p>{`SSR and SSG do the same thing: Serve a page with data baked-in.`}</p>
    <p>{`The difference is when that happens. When you deploy your site (Gatsby), when the first user hits a page (NextJS), or when every user hits the page (NextJS)?`}</p>
    <p>{`Each approach gives you different performance characteristics.`}</p>
    <ol>
      <li parentName="ol">{`Gatsby build-time rendering creates slow deploys and fantastic time to first byte for every user`}</li>
      <li parentName="ol">{`NextJS on-demand static pages create fast deploys, fantastic first load for most users, and terrible performance when cache is cold`}</li>
      <li parentName="ol">{`NextJS server side generation creates fast deploys, slow page loads, and a chance to do things pre-load`}</li>
    </ol>
    <p>{`Which is best depends on what you're doing.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: Gatsby looks like it's moving towards SSG, they now `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/blog/fs-route-api"
      }}>{`support filename-based dynamic routing`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      